import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useLayoutContext } from 'Context/LayoutContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import LeftDrawer from '../Desktop/LeftDrawer';
import MobileNavigation from '../Mobile';

export const DRAWER_WIDTH_CLOSED = 60;
export const DRAWER_WIDTH_OPEN = 250;

const useStyles = buildUseStyles('Template', (theme) => ({
  root: {},
  content: {},
  contentDesktop: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: '100vh',
    position: 'relative',
    marginLeft: DRAWER_WIDTH_CLOSED,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    paddingTop: 0,
  },
  contentDrawerOpen: {
    marginLeft: DRAWER_WIDTH_OPEN,
  },
}));

const DesktopLayout = React.forwardRef((props, ref) => {
  const {
    className,
    children,
    schema,
    ...rest
  } = props;
  const isMobile = useMobileLayout();
  const classes = useStyles();
  const {
    isNavigationOpen,
    isNavigationVisible,
  } = useLayoutContext();

  if (isNavigationVisible) {
    return (
      <div
        className={classNames(classes.root, className)}
        ref={ref}
        {...rest}
      >
        {isMobile ? (
          <MobileNavigation
            schema={schema}
          />
        ) : (
          <LeftDrawer
            schema={schema}
          />
        )}
        <main
          className={classNames(classes.content, {
            [classes.contentDesktop]: !isMobile,
            [classes.contentDrawerOpen]: !isMobile && isNavigationOpen,
          })}
        >
          {children}
        </main>
      </div>
    );
  }

  return (
    <div
      ref={ref}
      {...rest}
    >
      {children}
    </div>
  );
});

DesktopLayout.defaultProps = {
  className: '',
};

DesktopLayout.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  schema: PropTypes.object.isRequired,
};


export default DesktopLayout;
